import React, { useState } from 'react';
import { isNil } from 'ramda';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import { UserResource } from '~~apis/resource';
import { useQuery } from '~~utils/CommonUtils';
import IconEmail from './assets/IconEmail.svg';
import IconPassword from './assets/IconPassword.svg';
import { StyledForm } from './Styles';
import { STATUS } from './LoginConsts';
import { isEmbeddedWebview } from './Const';

const SignInForm = ({ handleForgetPassword }) => {
  const query = useQuery();
  const doneURL = query.get('done_url');
  const [loginData, setLoginData] = useState({
    email: '',
    password: '',
  });
  const [errorMsg, setErrorMsg] = useState(null);
  const [apiStatus, setApiStatus] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    setApiStatus('LOADING');

    UserResource.login({ email: loginData.email, password: loginData.password })
      .then(() => {
        setApiStatus('SUCCESS');
        setTimeout(() => {
          const targetURL = doneURL ? doneURL : process.env.REACT_APP_MAINPAGE_URL;
          window.location.href = targetURL;
          window.location.replace(targetURL);
        }, 500);
      })
      .catch((error) => {
        return handleError(error.message);
      });
  }

  function handleLoginFB(e) {
    e.preventDefault();
    const appendQuery = !doneURL ? '' : `?done_url=${doneURL}`;

    const targetURL = `${process.env.REACT_APP_BACKEND_URL}/auth/facebook${appendQuery}`;
    window.location.href = targetURL;
    window.location.replace(targetURL);
  }

  function handleLoginGoogle(e) {
    e.preventDefault();
    const appendQuery = !doneURL ? '' : `?done_url=${doneURL}`;

    const targetURL = `${process.env.REACT_APP_BACKEND_URL}/auth/google${appendQuery}`;
    window.location.href = targetURL;
    window.location.replace(targetURL);
  }

  function handleInputOnchange(e) {
    if (errorMsg) {
      setErrorMsg(null);
    }

    const value = e.target.value;
    const key = e.target.name;
    setLoginData({
      ...loginData,
      [key]: value,
    });
  }

  function handleKeyPress(e) {
    if ('Enter' !== e.key) {
      return;
    }

    e.preventDefault();
    if (handleCheckDisabled()) {
      return;
    }

    return handleSubmit(e);
  }

  function handleError(errorCode) {
    const status = 'ERROR';
    setApiStatus(status);
    let errorMessage = '發生錯誤，請稍後再試，或與我們聯絡。';
    switch (errorCode) {
      case 'WRONG_EMAIL_OR_PASSWORD':
        errorMessage = '帳號或密碼錯誤';
        break;
      case 'INVALID_FORMAT':
        errorMessage = '格式錯誤';
        break;
      default:
        break;
    }
    setErrorMsg(errorMessage);
  }

  function handleCheckDisabled() {
    const isAnyEmpty = Object.keys(loginData).some((item) => loginData[item] === '' || isNil(loginData[item]));
    const result = isAnyEmpty || apiStatus === 'LOADING';
    return result;
  }

  return (
    <StyledForm onSubmit={(e) => handleSubmit(e)} autoComplete="off" status={STATUS.SIGN_IN}>
      <div className="upper-box">
        社群登入
        <div className="connection-btns-box">
          <Button boxShadow onClick={handleLoginFB}>
            {' '}
            Facebook{' '}
          </Button>
          {!isEmbeddedWebview() && (
            <Button boxShadow onClick={handleLoginGoogle}>
              {' '}
              Google{' '}
            </Button>
          )}
        </div>
      </div>
      <div className="bottom-box">
        {/* 信箱 */}
        <div className="input-field">
          <img src={IconEmail} alt="Email" />
          <Input
            placeholder="信箱"
            name="email"
            onChange={handleInputOnchange}
            onKeyPress={handleKeyPress}
            value={loginData.email}
          />
        </div>
        {/* 密碼 */}
        <div className="input-field">
          <img src={IconPassword} alt="Password" />
          <Input
            placeholder="密碼"
            name="password"
            type="password"
            onChange={handleInputOnchange}
            onKeyPress={handleKeyPress}
            value={loginData.password}
          />
        </div>
        <div className="error-msg">{errorMsg && errorMsg}</div>
        <Button boxShadow round width="50%" type="submit" disabled={handleCheckDisabled()}>
          登入
        </Button>
        <div className="forgot-pw-link" onClick={handleForgetPassword}>
          忘記密碼?
        </div>
      </div>
    </StyledForm>
  );
};

export default SignInForm;
